/*
  Here have all methods we provide as a programming interface
  inside of checkout
 */

import 'jquery';

/**
 * get the additionalData if there are some
 *
 * you can call getAdditionalData() to get all additional data from init purchase call
 *
 * or getAdditionalData(key) to only get a specific value. Since all values have to be a string,
 * it returns an empty string if key isn't present.
 *
 *
 */
(function ($, window, JSON) {
  let analyticsData = JSON.parse($('#analyticsData').html() || '{}');
  /**
   *
   * @param key
   * @returns {*|string|{}}
   */
  window.getAdditionalData = function (key) {
    let data = analyticsData['additionalData'] || {};
    if (key) {
      return data[key] || '';
    }
    return data;
  };
}(jQuery, window, JSON));

/**
 * get checkoutConfig
 *
 * gets the original config the checkout is created with.
 * call getCheckoutConfig() to get whole config object
 *
 * call getCheckoutConfig(key) to only get one value. Since values can be objects,
 * it returns null, if key isn't found.
 *
 */
(function ($, window, JSON) {
  let storageElement = $('#analyticsData'),
    analyticsData = JSON.parse(storageElement.html() || '{}'),
    serviceUrl = storageElement.data('url'),
    body = $('body');
  /**
   * @param key
   * @returns {*|null|{}}
   */
  window.getCheckoutConfig = function (key) {
    let data = analyticsData['checkoutConfig'] || {};
    if (key) {
      return data[key] || null;
    }
    return data;
  };

  /**
   * update checkoutconfig
   */
  body.on('plenigo.setConfig', function (event, config){
    // set our local variable
    console.log('set config with ' + typeof config, config);

    if (typeof config === 'object') {
      if (typeof analyticsData['checkoutConfig'] === 'object') {
        // assign: https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
        analyticsData['checkoutConfig'] = Object.assign(analyticsData['checkoutConfig'], config);
        // tell all included scripts, we got a new config
        try {
          document.dispatchEvent(
            new window.CustomEvent('plenigo.ConfigChanged', {detail: analyticsData['checkoutConfig']})
          );
        } catch (e) {
          console.warn('Error during generating custom events');
        }
      }
      // store new config in session
      $.ajax({
        url: serviceUrl,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(config),
        contentType: 'application/json',
      });
    }
  });
}(jQuery, window, JSON));

/**
 * get cookies
 *
 * Since our application will not have any cookies, we have to retrieve cookies from outside
 * and put it in our window object.
 */
(function (window) {

  window.cookies = window.cookies || '';
  /**
   * @see https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/
   * butt different approaches are
   * @param name
   * @returns {string|null}
   */
  window.getCookie = function (name) {
    let v = window.cookies.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  };

}(window));

/**
 * get Remote Content and put it into checkout
 *
 * method getRemoteContent puts the whole html found at url beside checkout
 * call it getRemoteContent(page, url). Both parameters are mandatory.
 * page: RouteName of the page, the external content should be displayed at
 * url: Url of content source
 *
 * Note: URL MUST be HTTPS
 *
 */
(function ($, window) {
  /**
   *
   * @param page
   * @param url
   */
  window.getRemoteContent = function (page, url) {
    var xhr = new XMLHttpRequest();
    if (page !== $('body').data('page')) {
      return;
    }
    try {
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Content-Type', 'text/html; charset=utf-8');
      // the load event
      xhr.onreadystatechange = function () { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
          // Request finished. Do processing here.
          $('#remoteContent').html(this.response);
          $(document).trigger('plenigo.resize');
        }
      };

      xhr.send();

    } catch (e) {
      console.error(e.message);
    }
  };
}(jQuery, window));